import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { sendOtp, login, restartOtp } from "../../../redux/actions/authActions";
import ReCAPTCHA from "react-google-recaptcha";
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { LoadingButton } from '@mui/lab';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import RadioButtonUncheckedRoundedIcon from '@mui/icons-material/RadioButtonUncheckedRounded';
import TaskAltRoundedIcon from '@mui/icons-material/TaskAltRounded';

import "./Login.css";

function isIos() {
  const ua = navigator.userAgent || navigator.vendor || window.opera;
  return (/iPad|iPhone|iPod/.test(ua) && !window.MSStream);
}

/**
 * Hook: listens for an incoming SMS via the Web OTP API
 * and calls onCode(code) when it arrives.
 *
 * @param {(code: string) => void} onCode
 * @param {boolean} trigger – start listening when true
 */

const Login = ({ emergencyText }) => {
  const { otp, errorMsg } = useSelector((state) => state.auth);
  const { loading }      = useSelector((state) => state.async);
  const dispatch         = useDispatch();

  const [phone, setPhone]     = useState("");
   const [token, setToken] = useState(null);
  const [otpValue, setOtp]    = useState("");
  const [terms, setTerms]     = useState(true);
  const recaptchaRef         = React.useRef();

  // Determine when OTP form is visible
  const otpFormVisible = Boolean(otp && otp !== "fresh");
  // Auto-retrieve OTP on Android Chrome


  // Original iOS / URL-token logic
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const specToken = urlParams.get("spec_token");
    if (specToken) {
      dispatch(login({ spec_token: specToken }));
    } else if ("OTPCredential" in window && isIos()) {
      handleOtpRetrieval();
    }
  }, [dispatch]);

  // Original OTP-retrieval function
  const handleOtpRetrieval = () => {
    const ac = new AbortController();
    navigator.credentials
      .get({ otp: { transport: ["sms"] }, signal: ac.signal })
      .then((cred) => {
        setOtp(cred.code || cred);
      })
      .catch((err) => {
        /* ignore */
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!otpFormVisible) {
      dispatch(sendOtp({ phone, recaptcha: "token" }));
    } else {
      dispatch(login({ otp: otpValue, phone }));
    }
  };

  const CaptchaChange = (token) => {
    setToken(token);

  };
  const refreshOtp = () => {
    window.location.reload();
  };

  // Dynamic styling logic
  let hostname = window.location.hostname;
  if (hostname.startsWith("www.")) {
    hostname = hostname.substring(4);
  }
  const loginFormMap = {
    "mayanot-hasharon.anstc.com": { login_form_margin_top: "0px" },
    "yamim.anstc.com":             { login_form_margin_top: "90px" },
    "miahcom.anstc.com":           { login_form_margin_top: "90px" },
    "migdal-haemeq.anstc.com":     { login_form_margin_top: "90px" },
    "shefaram.anstc.com":          { login_form_margin_top: "90px" },
    "elad.anstc.com":              { login_form_margin_top: "60px" },
    "mayanotata.anstc.com":        { login_form_margin_top: "80px" },
    "yuvallim.anstc.com":          { login_form_margin_top: "80px" },
  };
  const { login_form_margin_top } = loginFormMap[hostname] || { login_form_margin_top: "0px" };

 if (emergencyText) {
    return (
      <div
        className="login_page"
        style={{ marginTop: login_form_margin_top }}
        
      >
        <div className="r_side">
        
          <h2 className="login_title">מערכת לזימון תורים</h2>

          {/* Render the server‐sent HTML */}
          <div
            className="emergency-text"
            dangerouslySetInnerHTML={{ __html: emergencyText }}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="login_page" style={{ marginTop: login_form_margin_top }}>
      <div className="r_side">
        <Box
          className="box_login"
          component="form"
          onSubmit={handleSubmit}
          sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }}
          noValidate
          autoComplete="off"
        >
          <h2 className="login_title">מערכת לזימון תורים</h2>
          <div className="content_login_form">
            {(!otp || otp === 'fresh') && (
              <TextField
                className="input_tel"
                style={{ width: '100%' }}
                required
                autoComplete="off"
                label="מספר נייד"
                onChange={(e) => setPhone(e.target.value)}
                placeholder="אנא הזן מספר נייד"
                type="tel"
              />
            )}

            {otp && otp !== 'fresh' && (
              <div className="otp_form">
                <TextField
                  style={{ width: '100%', direction: 'rtl' }}
                  required
                  value={otpValue}
                  onChange={(e) => setOtp(e.target.value)}
                  label="קוד אימות"
                  placeholder="אנא הזן סיסמא שנשלחה ב - SMS"
                  type="tel"
                  inputProps={{
                    inputMode: 'numeric',
                    pattern: '[0-9]*',
                    autoComplete: 'one-time-code'
                  }}
                />
                {errorMsg && <div className="errorMsg">{errorMsg}</div>}
                <div className="restert" onClick={refreshOtp}>
                  לא קיבלתי קוד, שלח שוב
                </div>
              </div>
            )}
          </div>
          <LoadingButton
            disabled={!terms || !phone}
            loading={loading}
            onClick={handleSubmit}
            variant="contained"
            className="login-btn"
            fullWidth
            sx={{ borderRadius: 0, fontSize: 18 }}
          >
            {!otp ? "שלח קוד" : "התחבר"}
          </LoadingButton>
        </Box>
      </div>
    </div>
  );
};

export default Login;
